/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/partners/${encodeURIComponent(request.path['partnerCode'] as any)}/users/${encodeURIComponent(request.path['email'] as any)}/help-link`,
    // @ts-ignore for sm-axios
    urlTemplate: '/partners/{partnerCode}/users/{email}/help-link',
    method: 'GET',
    headers: request.headers,
  })
}

/**
 * Retrieves the correct two step authentication help link key
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  headers?: {
    'x-sm-trace-token'?: string
  }
  path: {
    email: string
    partnerCode: string
  }
}

export interface Response {
  helpLinkKey:
    | 'SITEMINDER_PLATFORM_ENABLED_2SA_HELP_LINK'
    | 'SITEMINDER_NON_PLATFORM_ENABLED_2SA_HELP_LINK'
    | 'LITTLE_HOTELIER_PLATFORM_ENABLED_2SA_HELP_LINK'
    | 'LITTLE_HOTELIER_NON_PLATFORM_ENABLED_2SA_HELP_LINK'
}

